import React from 'react';
import SMHomeHostMainBannerView from './SMHomeHostMainBannerView';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMHomeSearchFormView from './SMHomeSearchFormView';
import SMHomeRoomView from './SMHomeRoomView';
import SMUserResource from 'resources/SMUserResource';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMHomeStaffFeaturesView from './SMHomeStaffFeaturesView';
import SMHomePromotionListView from './SMHomePromotionListView';

class SMHomeView extends React.Component {

  constructor(props) {
    super(props);
    this.startDate = '';
    this.mainGroup = [];
    this.subGroup = [];
    this.otherGroup = [];
    {this.props.eventTypeAllList.forEach((eventType, index)=>{
      if (['party', 'class', 'photo_shoot'].indexOf(eventType.name) != -1){
        this.mainGroup.push(eventType);
      }
      else if (['film_shoot', 'event', 'stay', 'other'].indexOf(eventType.name) != -1){
        this.subGroup.push(eventType);
      }
      else if (['performance', 'studio', 'sports', 'office', 'wedding', 'other'].indexOf(eventType.name) != -1){
        this.otherGroup.push(eventType);
      }
    });}

    this.state = {
      location: this.props.location || '',
      keyword: this.props.keyword || '',
      favoriteRoomIds: [],
      historyItems: [],
      favoriteItems: [],
      browseHistoryItems: [],
      eventType: '',
      priceType: '',
      isOpenSearchGroup1: false,
      isOpenSearchGroup2: false,
      activeSlideIndex: 0,
    };
  }

  componentDidMount() {
    this.campaignIndex = Math.floor( Math.random() * 3);
    if (this.props.currentUser) {
      this.setState({
        favoriteRoomIds: this.props.currentUser.favorite_room_ids,
      });
      this.requestFavoriteResource();
    }
    SMTrackHelper.criteoHome(this.props.currentUser ? this.props.currentUser.email : "");
  }

  changeFavoriteRoomIds(RoomId, funcName) {
    let favoriteRoomIds = this.state.favoriteRoomIds;
    if (funcName == "postFavorite") {
      favoriteRoomIds.push(RoomId);
    } else if (funcName == "deleteFavorite") {
      favoriteRoomIds.some(function(favoriteRoomId, i) {
        if (favoriteRoomId == RoomId) favoriteRoomIds.splice(i,1);
      });
    }
    this.setState({
      favoriteRoomIds: favoriteRoomIds,
    });
  }

  requestFavoriteResource() {
    if (!this.props.currentUser) return;
    let queries = {per_page: 3};
    SMUserResource.getFavorites(this.props.currentUser.username, queries, (responses, error, xhr)=>{
      if(error || !responses) return;
      this.setState({
        favoriteItems: responses,
      });
    });
  }

  eventTypeOtherDidSelect(e) {
    const category = e.currentTarget.value;
    window.location.href = Routes.search_index_path({event_type: category, with_recommend: 'true'});
    this.setState({eventType: category});
  }

  eventTypeDidSelect(e) {
    return;
    // for AB Testing
    // if ($('body').data('search-form') == 1) return;
    // if (SMAppHelper.isMobile()) return;
    e.preventDefault();
    const $target = $(e.currentTarget);
    const group = $target.data('group');
    const category = $target.data('category');

    let state = {};
    if (this.state.eventType == category) {
      state['eventType'] = null;
      state['priceType'] = null;
      state['isOpenSearchGroup' + group] = false;

    } else {
      state['eventType'] = category;
      state['isOpenSearchGroup1'] = (group == 1) ? true : false;
      state['isOpenSearchGroup2'] = !state['isOpenSearchGroup1'];
      state['priceType'] = (category == 'stay') ? 'stay' : 'hourly';
    }
    this.setState(state);
  }

  shuffle(array) {
    let m = array.length, t, i;
    while (m) {
      i = Math.floor(Math.random() * m--);
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
    return array;
  }

  renderStaffFeatures() {
    return(
      <div className="page__stripes top-page__padding">
        <SMHomeStaffFeaturesView
          staffFeatures={this.props.staffFeatures}
        />
      </div>
    );
  }

  renderEventTypeRooms(eventType) {
    const nameText = I18n.t(`service.event_type.${eventType.name}`);
    return(
      <div key={eventType.name} className="page__stripes top-page__padding">
        <div className="container top-container">
          <div className="top-title__container clearfix">
            <h2 className="top-title">{nameText}</h2>
            <a href={Routes.search_index_path({event_type: eventType.name})} className="pc-hide__sm-show top-more__area-link">もっと見る</a>
          </div>
          <div className="top-units__container">
            <div className="row">
              {this.props.eventTypeRooms[eventType.name].map((room, index) => {
                return (
                  <SMHomeRoomView
                    key={room.id}
                    delegate={this}
                    rank={index}
                    currentUser={this.props.currentUser}
                    room={room}
                    shouldSuffix={false} />
                );
              })}
            </div>
          </div>
          <div className="sm-hide top-more__area">
            <a href={Routes.search_index_path({event_type: eventType.name})} className="top-more__area-link">{nameText}で利用できるスペースをもっと見る</a>
          </div>
        </div>
      </div>
    );
  }

  renderBrowseHistory() {
    if (!this.state.browseHistoryItems.length) return null;
    return(
      <div className={`page__${++this.evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
        <div className="container">
          <h2 className="top-title">{I18n.t('service.label_000055')}</h2>
          <div className="row">
          {(()=>{
            let rows = [];
            for (let rowIndex = 0; rowIndex < 16; rowIndex++) {
              const room = this.state.browseHistoryItems[rowIndex];
              if(!room) break;
              rows.push(
                <div key={rowIndex} className="col-sm-12 col-md-3">
                  <SMHomeRoomView
                    delegate={this}
                    currentUser={this.props.currentUser}
                    room={room} />
                </div>
              );
            }
            return rows;
          })()}
          </div>
        </div>
      </div>
    );
  }

  renderFavorite() {
    if (!this.state.favoriteItems.length) return null;
    return (
      <div className="page__stripes top-page__padding">
        <div className="container top-container">
          <div className="top-title__container clearfix">
            <h2 className="top-title">{I18n.t('service.label_000051')}</h2>
            <a href={Routes.dashboard_favorite_lists_path()} className="pc-hide__sm-show top-more__area-link">{I18n.t('service.label_000052')}</a>
          </div>
          <div className="top-units__container">
            <div className="row">
            {(()=>{
              let rows = [];
              for (let rowIndex = 0; rowIndex < 4; rowIndex++) {
                const room = this.state.favoriteItems[rowIndex];
                if(!room) continue;
                rows.push(
                  <SMHomeRoomView
                    key={room.id}
                    delegate={this}
                    currentUser={this.props.currentUser}
                    room={room} />
                );
              }
              return rows;
            })()}
            </div>
          </div>
          <div className="sm-hide top-more__area">
            <a href={Routes.dashboard_favorite_lists_path()} className="top-more__area-link">{I18n.t('service.label_000052')}</a>
          </div>
        </div>
      </div>
    );
  }

  // Martini表示期間中は使用しない
  renderCampaign() {
    if (this.campaignIndex == null) return null;
    let banner = null;
    switch (this.campaignIndex) {
      case 0:
        banner = (
          <a href="http://passmarket.yahoo.co.jp/main/special/spacemarket" target="_blank">
            <div className="top-campaign top-campaign__pasma clearfix">
              <div className="top-campaign__header">
                <h3 className="top-campaign__header-title">会場探し、告知＆チケット販売まで<br />イベント主催の課題を全て解決</h3>
                <p className="top-campaign__header-logo"><img src={SMRailsBridge.assetPath.campaignPasmaLogo} alt="" /></p>
                <p className="top-campaign__header-more">{I18n.t('service.label_000056')}</p>
              </div>
            </div>
          </a>
        );
        break;
      case 1:
        banner = (
          <a href="http://www.link-ep.co.jp/information/" target="_blank">
            <div className="top-campaign top-campaign__le clearfix">
              <div className="top-campaign__header">
                <h3 className="top-campaign__header-title">会場探しからイベントのコンテンツ企画まで<br />皆様のお悩みを解決</h3>
                <p className="top-campaign__header-logo"><img src={SMRailsBridge.assetPath.campaignLeLogo} alt="" /></p>
                <p className="top-campaign__header-more">{I18n.t('service.label_000056')}</p>
              </div>
            </div>
          </a>
        );
        break;
      case 2:
        banner = (
          <a href={Routes.feature_path({id:'primechef'})} target="_blank">
            <div className="top-campaign top-campaign__primechef clearfix">
              <div className="top-campaign__header">
                <h3 className="top-campaign__header-title">場所も料理も「好き」を組み合わせて、<br />リッチもカジュアルもあなたらしいパーティーを</h3>
                <p className="top-campaign__header-logo"><img src={SMRailsBridge.assetPath.campaignPrimeChefLogo} alt="" /></p>
                <p className="top-campaign__header-more">{I18n.t('service.label_000056')}</p>
              </div>
            </div>
          </a>
        );
        break;
    }
    return(
      <div className={`page__${++this.evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
        <div className="container">
          {banner}
        </div>
      </div>
    );
  }

  renderMartiniCampaign() {
    return(
      <div className={`page__${++this.evenCount % 2 == 0 ? 'even' : 'odd'} page__padding`}>
        <div className="container">
          <a href="http://pr.spacemarket.com/martini" target="_blank">
            <div className="top-campaign__martini">
              <div className="top-campaign clearfix">
                <div className="top-campaign__header">
                  <p className="top-campaign__header-pickup">東京・大阪</p>
                  <p className="top-campaign__header-pickup">期間限定</p>
                  <h3 className="top-campaign__header-title">
                    <span className="top-campaign__header-title-re">MARTINI</span>が飲める<br />スペシャルスペース登場！
                  </h3>
                  <p className="top-campaign__header-text">この冬、特別なパーティを開催しませんか？</p>
                  <p className="top-campaign__header-logo">
                    <img src={SMRailsBridge.assetPath.campaignMartiniLogo} alt="SPACEMARKET × MARTINI" />
                  </p>
                </div>
              </div>
              <p className="top-campaign__header-more">{I18n.t('service.label_000056')}</p>
            </div>
          </a>
        </div>
      </div>
    );
  }

  renderSignUpCoupon() {
    return (
      <div className="page__stripes top-page__padding">
        <div className="container">
          <div className="top-more__area top-flow__regist">
            <div className="top-bonus__points"><p className="top-bonus__points-inner">今なら2,000ポイントプレゼント！</p></div>
            <h2 className="top-flow__regist-title">{I18n.t('service.label_000059')}</h2>
            <a href={Routes.new_user_registration_path()} className="button-blue top-more__area-button top-flow__regist-button">{I18n.t('service.label_000060')}</a>
            <p className="top-bonus__text">今なら会員登録した方全員に、すべてのスペースの予約で利用できる2,000円分のポイントをプレゼント。</p>
          </div>
        </div>
      </div>
    );
  }

  renderBrandingIcons() {
    return (
      <div className="top-page__appeal page__padding">
        <div className="container">
          <h3 className="top-appeal__title">{I18n.t('service.label_000053')}</h3>
            <ul className="top-appeal__list clearfix">
              <li><a href="http://spacemarket.co.jp/archives/5331" target="_blank"><img src={SMRailsBridge.assetPath.mediaNHK} alt="NHK" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5381" target="_blank"><img src={SMRailsBridge.assetPath.mediaNikkei} alt="日経新聞" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/6061" target="_blank"><img src={SMRailsBridge.assetPath.mediaFujiTV} alt="フジテレビ" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5621" target="_blank"><img src={SMRailsBridge.assetPath.mediaTBS} alt="TBS" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5621" target="_blank"><img src={SMRailsBridge.assetPath.mediaAsahi} alt="朝日新聞" /></a></li>
              <li><a href="http://diamond.jp/articles/-/60963" target="_blank"><img src={SMRailsBridge.assetPath.mediaYahoo} alt="ヤフーニュース" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/5471" target="_blank"><img src={SMRailsBridge.assetPath.mediaYomiuri} alt="読売新聞" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/721" target="_blank"><img src={SMRailsBridge.assetPath.mediaJwave} alt="JWAVE" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/7261" target="_blank"><img src={SMRailsBridge.assetPath.mediaReuters} alt="ロイター" /></a></li>
              <li><a href="http://spacemarket.co.jp/archives/7351" target="_blank"><img src={SMRailsBridge.assetPath.mediaR25} alt="R25" /></a></li>
            </ul>
          <h3 className="top-appeal__title clearfix">{I18n.t('service.label_000054')}</h3>
            <ul className="top-appeal__list">
              <li><img src={SMRailsBridge.assetPath.companyTechInAsia} alt="TechInAsia" /></li>
              <li><img src={SMRailsBridge.assetPath.companyBase} alt="Base" /></li>
              <li><img src={SMRailsBridge.assetPath.companyCa} alt="CyberAgent" /></li>
              <li><img src={SMRailsBridge.assetPath.companyCrazy} alt="Crazy" /></li>
              <li><img src={SMRailsBridge.assetPath.companyKaizen} alt="Kaizen Platform" /></li>
              <li><img src={SMRailsBridge.assetPath.companyYjfx} alt="YJFX" /></li>
              <li><img src={SMRailsBridge.assetPath.companyTracos} alt="TransCosmos" /></li>
              <li><img src={SMRailsBridge.assetPath.companyWantedly} alt="Wantedly" /></li>
              <li><img src={SMRailsBridge.assetPath.companyLe} alt="Link Event Produce" /></li>
            </ul>
        </div>
      </div>
    );
  }

  renderSignUp() {
    return (
      <div className="mod-banner mod-banner__guest">
        <div className="container">
          <h3>{I18n.t('service.label_000059')}</h3>
          <p>{I18n.t('service.label_000061')}</p>
          <a href={Routes.new_user_registration_path()} className="mod-banner__button">{I18n.t('service.label_000060')}</a>
        </div>
      </div>
    );
  }

  renderConciergeArea() {
    return(
      <div className="top-static__banner top-corp-concierge__banner">
        <div className="container">
          <h3 className="top-static__banner-title">法人でスペースをお探しの方へ</h3>
          <p className="top-static__banner-text">スペースマーケットの法人コンシェルでは法人の方のイベント開催をまるごとサポートいたします！</p>
          <a href={Routes.concierge_index_path()} className="button-blue top-static__banner-button">もっと詳しく</a>
        </div>
      </div>
    );
  }

  renderSearchForm() {
    return(
      <div className="top-mv">
        <p className="service-logo"><img src={SMRailsBridge.assetPath.serviceLogo} alt={I18n.t('service.name')} /></p>
        <h1 className="top-information__sub">{this.props.totalRoomsCount}件のレンタルスペースから <br className="pc-hide__sm-show" />目的に合ったスペースをかんたん予約</h1>
        <div className="page__information">
          <div className="top-menu__container">
            <div className="container">
              <ul className="row">
                {this.mainGroup.map((eventType, index)=>{
                  const category = eventType.name;
                  const nameText = I18n.t(`service.event_type.${category}`);
                  const isCurrent = (eventType.name == this.state.eventType);
                  const className = 'top-menu__list-button mdl-shadow--2dp' + (isCurrent ? ' is-current' : '');
                  return(
                    <li key={category} className="top-menu__list col-xs-4">
                      <a data-group="1" data-category={category}
                        onClick={this.eventTypeDidSelect.bind(this)}
                        href={Routes.search_index_path({event_type: category, with_recommend: 'true'})}
                        className={className}>
                        <img src={SMRailsBridge.assetPath[`topEventType_${category}`]} alt={nameText} className="top-menu__list-button-img" />
                        <span className="top-menu__list-button-text">{nameText}<span className="top-menu__list-button-num">{eventType.rooms_count}件</span></span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
            <CSSTransitionGroup transitionName="js-initial-animation"
              transitionAppear={false}
              transitionEnter={true}
              transitionEnterTimeout={300}
              transitionLeave={false}>
              {(()=>{
                if (!this.state.isOpenSearchGroup1) return null;
                return (
                  <div className="search-box search-box-child">
                    <form action={Routes.search_index_path()} method="get">
                      <SMHomeSearchFormView
                        eventType={this.state.eventType}
                        priceType={this.state.priceType}
                        capacityList={this.props.capacityList}
                        group={1}
                      />
                    </form>
                  </div>
                );
              })()}
            </CSSTransitionGroup>

            <div className="container">
              <ul className="row">
                {this.subGroup.map((eventType, index)=>{
                  const category = eventType.name;
                  const nameText = I18n.t(`service.event_type.${category}`);
                  const isCurrent = (eventType.name == this.state.eventType);
                  const className = 'top-menu__list-button mdl-shadow--2dp' + (isCurrent ? ' is-current' : '');
                  if (category == 'other') {
                    return (
                      <li key={category} className="top-menu__list top-menu__list-second col-xs-3">
                        <a href={Routes.search_index_path({event_type: category})}
                          className={className}>
                          <img src={SMRailsBridge.assetPath[`topEventType_${category}`]} alt="" className="top-menu__list-button-img" />
                          <span className="top-menu__list-button-text">{nameText}</span>
                        </a>
                        <select name="others" className="w100pa js-select__transparent" onChange={this.eventTypeOtherDidSelect.bind(this)}>
                          <option key="none" value="">{I18n.t('service.label_000047')}</option>
                          {this.otherGroup.map((eventType, index)=>{
                            const category = eventType.name;
                            const nameText = I18n.t(`service.event_type.${category}`);
                            return(
                              <option key={category} value={category}>{nameText}</option>
                            );
                          })}
                        </select>
                      </li>
                    );
                  } else {
                    return (
                      <li key={category} className="top-menu__list top-menu__list-second col-xs-3">
                        <a data-group="2" data-category={category}
                          onClick={this.eventTypeDidSelect.bind(this)}
                          href={Routes.search_index_path({event_type: category, with_recommend: 'true'})}
                          className={className}>
                          <img src={SMRailsBridge.assetPath[`topEventType_${category}`]} alt="" className="top-menu__list-button-img" />
                          <span className="top-menu__list-button-text">{nameText}<span className="top-menu__list-button-num">{eventType.rooms_count}件</span></span>
                        </a>
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
            <CSSTransitionGroup transitionName="js-initial-animation"
              transitionAppear={false}
              transitionEnter={true}
              transitionEnterTimeout={300}
              transitionLeave={false}>
              {(()=>{
                if (!this.state.isOpenSearchGroup2) return null;
                return (
                  <div className="search-box search-box-child">
                    <form action={Routes.search_index_path()} method="get">
                      <SMHomeSearchFormView
                        eventType={this.state.eventType}
                        priceType={this.state.priceType}
                        capacityList={this.props.capacityList}
                        group={2}
                      />
                    </form>
                  </div>
                );
              })()}
            </CSSTransitionGroup>
          </div>
          <div className="top-menu__other-search">
            <h3 className="top-menu__other-ttl">カテゴリーから探す</h3>
            <ul className="top-flow__list">
              <li><a href={Routes.areas_path()}>エリア</a></li>
              <li><a href={Routes.capacities_path()}>人数</a></li>
              <li><a href={Routes.space_types_path()}>会場タイプ</a></li>
              <li><a href={Routes.amenities_path()}>アメニティ</a></li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  renderPromotionList() {
    if (
      this.props.promotions !== undefined &&
      this.props.promotions !== null &&
      this.props.promotions.length > 0
    ) {
      return (
        <div className="page__stripes top-page__padding">
          <SMHomePromotionListView
            promotions={this.props.promotions}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  renderReferral() {
    return (
      <div className="page__stripes top-page__padding">
        <div className="container">
          <div className="top-more__area top-flow__regist">
            <div className="top-bonus__points">
              <p className="top-bonus__points-inner">スペースマーケット招待キャンペーン</p>
            </div>
            <h2 className="top-flow__referral-title">招待したあなたにも、招待された友だちにも<br />
              <span>もれなく2,000ポイントプレゼント！</span>
            </h2>
            <a href={Routes.referrals_path()} className="button-blue top-flow__regist-button">友だちを招待する</a>
          </div>
        </div>
      </div>
    );
  }

  render() {

    this.evenCount = -1;
    if (this.props.currentUser) {
      return(
        <div className="site-main">
          {this.renderSearchForm()}
          <div />
          {this.renderFavorite()}
          {this.renderStaffFeatures()}
          {this.renderPromotionList()}
          {this.renderReferral()}
          {this.props.eventTypeList.map((eventType, index)=>{
            if (0 <= index && index < 3) return this.renderEventTypeRooms(eventType);
          })}
          <SMHomeHostMainBannerView />
          {this.props.eventTypeList.map((eventType, index)=>{
            if (3 <= index && index < 6) return this.renderEventTypeRooms(eventType);
          })}
          {this.renderConciergeArea()}
          {this.props.eventTypeList.map((eventType, index)=>{
            if (6 <= index) return this.renderEventTypeRooms(eventType);
          })}
          {this.renderBrowseHistory()}
          {/* this.renderCampaign() */}
          {this.renderMartiniCampaign()}
          {this.renderBrandingIcons()}
        </div>
      );

    } else {
      return(
        <div className="site-main">
          {this.renderSearchForm()}
          <div />
          {this.renderStaffFeatures()}
          {this.renderPromotionList()}
          {this.renderSignUpCoupon()}
          {this.props.eventTypeAllList.map((eventType, index)=>{
            if (0 <= index && index < 3) return this.renderEventTypeRooms(eventType);
          })}
          <SMHomeHostMainBannerView />
          {this.props.eventTypeAllList.map((eventType, index)=>{
            if (3 <= index && index < 6) return this.renderEventTypeRooms(eventType);
          })}
          {this.renderConciergeArea()}
          {this.props.eventTypeAllList.map((eventType, index)=>{
            if (6 <= index && index < 11) return this.renderEventTypeRooms(eventType);
          })}
          {this.renderSignUp()}
          {/* this.renderCampaign() */}
          {this.renderMartiniCampaign()}
          {this.renderBrandingIcons()}
        </div>
      );
    }
  }
}
export default SMHomeView;



// WEBPACK FOOTER //
// ./app/javascript/components/home/SMHomeView.jsx